import { atomFamily } from "recoil";

export enum DownloadUrlForEmailStatus {
  NOT_LOADED = "not-loaded",
  LOADING = "loading",
  LOADED = "loaded",
}

export const downloadUrlForEmailState = atomFamily<
  {
    url: string;
    status: DownloadUrlForEmailStatus;
  },
  string | null
>({
  key: "DownloadUrlForEmailState",
  default: {
    url: "",
    status: DownloadUrlForEmailStatus.NOT_LOADED,
  },
});
